import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCode = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.29294 6.29297L2.58594 12L8.29294 17.707L9.70694 16.293L5.41394 12L9.70694 7.70697L8.29294 6.29297ZM15.7069 17.707L21.4139 12L15.7069 6.29297L14.2929 7.70697L18.5859 12L14.2929 16.293L15.7069 17.707Z",
		fill: "currentColor"
	})
});
export default SvgCode;
